import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLoginService} from '../services/person-login-service';
import { EntitySearchComponent } from '../entity/entity-search.component';

@Component({
    selector: 'quote-master',
    templateUrl: './quote-master.component.html',
    styleUrls: ['./quote-master.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntitySearchComponent]
})
export class QuoteMasterComponent {
  private router = inject(Router);
  private personLoginService = inject(PersonLoginService);


  public entityName = "QUOTE";
  public showAllFilters: boolean = false;

  constructor
  () {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    }
    this.showAllFilters = this.personLoginService.isInternalOrRsm() || this.personLoginService.isSiblingOrgUser();
  }

  public newQuote(organizationId: string): void {
    if (organizationId && organizationId.length > 0) {
      this.router.navigate(['quotes/new/0'], {queryParams: {orgUnitId: organizationId}});
    } else {
      this.router.navigate(['quotes/new/0']);
    }
  }

  public goToDetail(entityHeader: any) {
    if (entityHeader) {
      this.router.navigate(['quotes', entityHeader.id.entityId, entityHeader.id.entityRevision]);
    }
  }

}
